module.exports = __webpack_public_path__ + "img/badge_gestione_dipendenti.3669a0dc.jpg";